export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/traveler-top.d78b3cae-7aa1e8.svg";